module.exports = __webpack_public_path__ + "static/twopackfloralonesies-23876f149a775e7e6ef29347511359d3.jpeg";